//noinspection JSUnusedLocalSymbols
(function($) {
	'use strict';

	/**
	 * SportEvent (based on the "sportal" data)
	 *
	 * @author Dave Talamona
	 * @class SCS.SportEvents.Event
	 */

	// init namespace
	window.SCS = window.SCS || {};
	window.SCS.SportEvents = window.SCS.SportEvents || {};


	var zeroFill = require('lib/util/helpers').zeroFill;

	// private variables with class scope
	var privatesInitialized = false,
		now, language, // definition in helper function "initPrivates"
		oneHourMilliseconds = 60 * 60 * 1000,
		oneDayMilliseconds = 24 * oneHourMilliseconds,
		endNotDefinedOffset = 4 * oneHourMilliseconds, // [ms] If an event has no end defined in the stream info then the start is taken and this offset is added (advice and definition of duration by Alain Vergères, 09.03.2015)
		languageFallbackChane = ['browser', 'en', 'de', 'first']; // 'browser' is the browsers language, 'first' is the first language that is found

	// constructor
	window.SCS.SportEvents.Event = function (json) {
		var i, j, counter, start, end, tvDataStore;

		// class init
		if (!privatesInitialized) {
			privateHelpers.initPrivates();
		}

		// save json data for later use in other scripts
		this.json = json;

		this.id = json.MATCHID;

		this.date = new Date(Number(json.DATE) * 1000);
		this.time = json.TIME;

		this.title = json.HEADLINE;
		this.sport = json.SPORT;
		this.sportid = (json.SPORTID != '' ? json.SPORTID : json.SPORT.toLowerCase());
		this.competition = json.COMPETITION;
		this.descr = this.sport + (this.sport && this.competition ? ', ' : '') + this.competition;

		this.result = (json.RESULT ? json.RESULT.replace(/,\s*/g, ', ') : ''); // json.RESULT can be null

		this.reference = json.REFERENCE;

		this.language = '';

		// check for FreeTv schedule
		{
			this.freeTvData = null;
			tvDataStore = [];

			start = SCS.utils.date.fromString(json['TVSTARTFREE']);
			end = SCS.utils.date.fromString(json['TVENDFREE']);

			// find all valid broadcasts
			for (i = 0, counter = ''; i <= 8; i++, counter = i) { // According to the specification there are 9 senders 0 to 8. 0 is no number in the name => SENDER, SENDER1, SENDER2, ...SENDER8.
				if (json['SENDER' + counter] && json['SENDER' + counter + 'LANGUAGE']) {
					tvDataStore.push({
						sender: json['SENDER' + counter],
						start: start,
						end: end,
						language: json['SENDER' + counter + 'LANGUAGE'].toLowerCase()
					});
				}
			}

			// find the the broadcasts with best matching language (according to setting in "languageFallbackChane" variable)
			for (i = 0; !this.freeTvData && i < languageFallbackChane.length; i++) {
				for (j = 0; !this.freeTvData && j < tvDataStore.length; j++) {
					if (
						tvDataStore[j].language == languageFallbackChane[i] ||
						(languageFallbackChane[i] == 'browser' && tvDataStore[j].language == language) ||
						languageFallbackChane[i] == 'first'
					) {
						this.freeTvData = tvDataStore[j];
						this.language = this.freeTvData.language;
					}
				}
			}
		}

		// check for PPV schedule
		{
			this.ppvData = null;
			tvDataStore = [];

			if (json.PPVCH == 'ja' && !this.freeTvData) {
				// find all valid broadcasts
				for (i = 1, counter = ''; i <= 3; i++, counter = i) { // According to the specification there can be up to 3 pay per view identifiers, start and end times
					if (json['PROGRAMIDENTIFIER' + counter] && json['PROGRAMLANGUAGE' + counter]) {
						tvDataStore.push({
							identifier: json['PROGRAMIDENTIFIER' + counter],
							start: SCS.utils.date.fromString(json['TVSTART' + counter]),
							end: SCS.utils.date.fromString(json['TVEND' + counter]),
							language: json['PROGRAMLANGUAGE' + counter].toLowerCase()
						});
					}
				}

				// find the the broadcasts with best matching language (according to setting in "languageFallbackChane" variable)
				for (i = 0; !this.ppvData && i < languageFallbackChane.length; i++) {
					for (j = 0; !this.ppvData && j < tvDataStore.length; j++) {
						if (
							tvDataStore[j].language == languageFallbackChane[i] ||
							(languageFallbackChane[i] == 'browser' && tvDataStore[j].language == language) ||
							languageFallbackChane[i] == 'first'
						) {
							this.ppvData = tvDataStore[j];
							this.language = this.ppvData.language;
						}
					}
				}
			}
		}

		// set start and end time directly on the event
		if (this.freeTvData && this.freeTvData.start) {
			this.startTime = this.freeTvData.start;
			this.endTime = (this.freeTvData.end ? this.freeTvData.end : new Date(this.startTime.getTime() + endNotDefinedOffset));
		} else if (this.ppvData && this.ppvData.start) {
			this.startTime = this.ppvData.start;
			this.endTime = (this.ppvData.end ? this.ppvData.end : new Date(this.startTime.getTime() + endNotDefinedOffset));
		} else {
			this.startTime = this.date;
			this.endTime = new Date(this.date.getTime() + endNotDefinedOffset);
		}

		// correct differences in stream start time and given JSON date/time -> take stream time (advice and definition of duration by Alain Vergères, 09.03.2015)
		if (this.date.getTime() != this.startTime.getTime()) {
			this.date = this.startTime;
			this.time = zeroFill(this.date.getHours()) + ':' + zeroFill(this.date.getMinutes());
		}

		// set flags
		this.hasTicker = (json.TICKER == 'ja');
		this.hasStream = !!(this.freeTvData || this.ppvData);

		// set stream/timing status flags
		this.finished = (json.STATUS == 'fin' || now > this.endTime); // check for date because sometimes sportal does not set the status to "fin"
		this.today = ((now.getDate() == this.startTime.getDate() || now.getDate() == this.endTime.getDate()) || (now > this.startTime && !this.finished));
		this.tomorrow = ((new Date(now.getTime() + oneDayMilliseconds)).getDate() == this.startTime.getDate() && now > this.startTime - (2 * oneDayMilliseconds));
		this.live = (this.today && (json.STATUS == 'live' || (now >= this.startTime && now < this.endTime))); // check for today because sometimes sportal delivers LIVE markers for events in the future

		// set status css class (used by different modules)
		//noinspection JSUnusedGlobalSymbols
		this.cssClasses = (this.finished ? 'finished' : (this.live ? 'live' : 'scheduled'));

		// set details url
		this.url =
			location.href.match(/https?:\/\/.+?\/[a-z]{2}\//)[0] + // find the actual url starting with the protocol and including the language
			'sport/' + this.sportid +
			'/live-ticker.html#' + this.id;
	};

	// class
	window.SCS.SportEvents.Event.prototype = {
		constructor : window.SCS.SportEvents.Event
	};

	// helpers
	var privateHelpers = {
		initPrivates: function () {
			// get language of the actual page
			language = ($('html').attr('lang') || 'de').toLowerCase();

			// get servers time
			now = SCS.utils.getServerTime(); // can be a little off for browsers with different timezone (see JsDOc for detailed description)
		}
	};

})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.SportEvents.Event.js
// module id = 94
// module chunks = 0